<template>
  <div class="authstr-container">
    <header>
      <span class="title">收费信息</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="收款账户/名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="download" v-if="funAuth.includes(67)">导出</el-button>
        <el-button type="primary" :disabled="disabled || multipleSelection.length == 0" @click="paymentStatus" v-if="funAuth.includes(66)">已打款</el-button>
      </div>
    </header>
    <el-table ref='multipleTable' :data='tableList' tooltip-effect='dark' style='width: 100%' @selection-change='handleSelectionChange' class="el-table-01">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column label='收款类型'>
        <template  slot-scope='scope'>
            {{scope.row.payment_method === 2 ? "微信":"支付宝"}}
        </template>
      </el-table-column>
      <el-table-column prop='contacts' label='联系人姓名'></el-table-column>
      <el-table-column prop='phone' label='联系人手机号码'></el-table-column>
      <el-table-column prop='payment_total_amout' label='收款金额'></el-table-column>
      <el-table-column  label='收款时间'>
        <template  slot-scope='scope'>
          {{scope.row.payment_completion_time | formatDate('yyyy-MM-dd HH:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column prop='application_name' label='支付应用名称'></el-table-column>
      <el-table-column  label='是否处理'>
        <template  slot-scope='scope'>
          {{scope.row.payment_flag===0 ? '未处理':'已处理'}}
        </template>
      </el-table-column>
      <el-table-column  label='处理时间'>
        <template  slot-scope='scope'>
          {{scope.row.payment_time | formatDate('yyyy-MM-dd HH:mm:ss')}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>
  </div>
</template>
<script>
import axios from 'axios'
import {HTTPServer, baseURL} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>收费信息</b>',
      ellipsisStyle: '-webkit-line-clamp: 5;-webkit-box-orient: vertical;',
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      options1: [
        {id: '0', label: '免费'},
        {id: '1', label: '付费'}
      ],
      multipleSelection: [],
      disabled: true
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    this.applicationChargeBillRecordList()
    this.queryFchBtnAuth(({moduleId: 20}))
  },
  methods: {
    /** 获取列表 */
    applicationChargeBillRecordList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.applicationChargeBillRecordList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.applicationChargeBillRecordList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = this.multipleSelection.some(v => { return v.payment_flag === 1 })
      console.log(this.disabled)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.applicationChargeBillRecordList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.applicationChargeBillRecordList()
    },
    paymentStatus () {
      let ids = []
      this.multipleSelection.map(v => {
        ids.push(v.id)
      })
      this.$confirm('是否为已处理？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var jsondata = {'ids': ids.toString(), 'paymentFlag': 1}
        HTTPServer.updatePaymentStatusById(jsondata, 'Loading').then((res) => {
          this.applicationChargeBillRecordList()
        })
      }).catch(() => {
      })
    },
    download () {
      axios({
        method: 'get',
        responseType: 'blob',
        url: baseURL + 'applicationChargeBillRecord/export',
        baseURL: baseURL,
        // data: {paymentFlag: 0},
        params: {paymentFlag: 0},
        headers: JSON.parse(sessionStorage.requestHeader)
      })
        .then((response) => {
          var blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = '账单' + (new Date().getTime()) + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
.authstr-container{
  .ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/charge-bill.vue